import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { AdminSearch } from 'app/components/AdminSearchField';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import AddNewRole from './AddNewRole';
import RoleTable from './RoleTable';
import BackButton from 'app/components/BackButton';
import EditSaveButton from 'admin/components/EditSaveButton';
import useRolePermissionApi from './useRolePermissionApi';
import { Module, UserRoles } from 'services/openapi';
import { usePermissionsApi } from 'hooks/usePermissionsApi';
import { usePermission } from 'hooks/usePermission';
import Loader from 'app/components/Loader';
import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import { useErrorHandlingSlice } from 'app/error/slice';

type Props = {};
const breadCrumbItems = [
    {
        id: '',
        text: 'Showyeda admin',
        disabled: true,
    },
    {
        id: '/admin/settings',
        text: 'Settings',
    },
    {
        id: '',
        text: 'Roles',
        disabled: true,
    },
];
const Roles = (props: Props) => {
    const navigate = useNavigate();
    const { hasViewPermission } = usePermission();
    const dispatch = useDispatch();
    const { actions } = useErrorHandlingSlice();
    const {
        rolePermissionsList,
        getRolePermissionsList,
        setRolePermissionsList,
        handleCreateRolePermissions,
        roleName,
        loading: listLoading,
        saveLoading,
        setRoleName,
        permissionPayloadDefault,
        roleNameDefault
    } = usePermissionsApi();
    const {
        fetchPermissionRoleList,
        permissionRoleData,
        loading,
        handleDeleteRole,
    } = useRolePermissionApi();
    const [searchTerm, setSearchTerm] = useState<string>('');

    const [error, setError] = useState('');
    const { action, id } = useParams();
    const [filteredRoleData, setFilteredRoleData] = useState<UserRoles[]>([]);


    const handleRiderSearch = e => {
        const value = e.target.value;
        setSearchTerm(value);

        if (!permissionRoleData) return;

        if (!value) {
            setFilteredRoleData(permissionRoleData);
            return;
        }

        const searchTermLower = value.toLowerCase();
        const filtered = permissionRoleData.filter(role => {
            return role.name && role.name.toLowerCase().includes(searchTermLower);
        });

        setFilteredRoleData(filtered);
    };
    const handleOnCloseClick = () => {
        setSearchTerm('');
        if (permissionRoleData) {
            setFilteredRoleData(permissionRoleData);
        }
    };
    const onCancelClick = () => {
        if (action === 'add-role') {
            setRoleName('');
            setRolePermissionsList(permissionPayloadDefault);
        }
        else {
            if (!isEqual(permissionPayloadDefault, rolePermissionsList)) {
                setRolePermissionsList(permissionPayloadDefault);
            }

            if (roleName !== roleNameDefault) {
                setRoleName(roleNameDefault);
            }
        }
    };
    const onSaveClick = () => {
        if (action === 'add-role') {
            handleCreateRolePermissions({
                roleId: null,
                roleName: roleName,
                modules: rolePermissionsList,
            });
        } else {
            if (isEqual(permissionPayloadDefault, rolePermissionsList) && roleName === roleNameDefault) {
                dispatch(
                    actions.dispatchToast({
                        errorTxt: 'No changes have been made',
                        show: true,
                        errorType: 'error',
                    }),
                );
            }
            else {
                handleCreateRolePermissions({
                    roleId: id,
                    roleName: roleName,
                    modules: rolePermissionsList,
                });
            }

        }
    };
    useEffect(() => {
        fetchPermissionRoleList();
    }, [navigate]);
    useEffect(() => {
        if (permissionRoleData) {
            setFilteredRoleData(permissionRoleData);
        }
    }, [permissionRoleData]);
    useEffect(() => {
        if (id) {
            getRolePermissionsList(id);
        } else {
            getRolePermissionsList();
        }
    }, [id]);
    return (
        <CommonPageWrapper>
            {saveLoading && <Loader />}
            <HeadingWrapper>
                <PageMainLabel>
                    {action === 'add-role'
                        ? 'Add New Role'
                        : action === 'edit-role'
                            ? 'Role Information'
                            : 'Roles'}
                </PageMainLabel>
                <CustomBreadCrumb preData={breadCrumbItems} />
            </HeadingWrapper>
            {(action === 'add-role' || action === 'edit-role') && (
                <BtnWrapper className="Top-Btn-Wrapper">
                    <div>
                        <BackButton
                            onClick={() => {
                                window.history.back();
                            }}
                        />
                    </div>
                    <div className="btn-action">
                        <EditSaveButton
                            isEdit={false}
                            onCancelClick={onCancelClick}
                            cancelText="Clear"
                            onSaveClick={onSaveClick}
                            saveDisabled={
                                !roleName || roleName.trim() === '' || error !== ''
                            }
                        />
                    </div>
                </BtnWrapper>
            )}
            <ContentWrapper>
                {action === 'add-role' || action === 'edit-role' ? (
                    <AddNewRole
                        rolePermissionsList={rolePermissionsList ?? []}
                        setRolePermissionsList={setRolePermissionsList}
                        setRoleTitle={setRoleName}
                        roleTitle={roleName}
                        loading={listLoading}
                        setError={setError}
                        error={error}
                    />
                ) : (
                    <>
                        <BtnWrapper>
                            <div>
                                {hasViewPermission('0900101008') && (
                                    <AdminCustomButton
                                        buttonType="roleButton"
                                        onClick={() => {
                                            navigate(`/admin/settings/roles/add-role`);
                                            setRoleName('');
                                        }}
                                    >
                                        Add New Role
                                    </AdminCustomButton>
                                )}
                            </div>
                            <div className="btn-action">
                                <SearchWrapper>
                                    <AdminSearch
                                        placeholder="Search for a role"
                                        onSearchTextEntering={handleRiderSearch}
                                        searchTerm={searchTerm}
                                        onCloseClick={handleOnCloseClick}
                                    />
                                </SearchWrapper>
                            </div>
                        </BtnWrapper>
                        <RoleTable
                            data={filteredRoleData}
                            loading={loading}
                            debounceTeamSearch={searchTerm}
                            handleDeleteRole={handleDeleteRole}
                        />
                    </>
                )}
            </ContentWrapper>
        </CommonPageWrapper>
    );
};
export default Roles;
const SearchWrapper = styled.div`
  width: 283px;
`;
const ContentWrapper = styled.div`
  width: 100%;
  padding: 15px 30px 15px 0;
  .k-button {
    min-width: 125px;
  }
`;
const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 15px 0px 29px;
  .btn-action {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  button {
    padding: 0px;
  }
  &.Top-Btn-Wrapper {
    border-bottom: 1px solid #eaecf0;
  }
`;
